import {
  GET_FILTERD_MERGER,
  GET_MERGER,
  GET_MERGER_BY_ID,
  GET_MERGER_MINE,
  GET_MERGERS_ORDER_DETAILS,
  GET_MINE_MERGERS_ORDER_DETAILS,
} from "../constants/index";

export const mergers = (
  state = {
    getmergerslist: [],
    getmergersbyid: {},
    getminemergerslist: [],
    getfilterdmergers: {},
    minemergersorderlist:{},
    mergersorderlist:{},
  },
  action
) => {
  switch (action.type) {
    case GET_MERGER:
      return { ...state, getmergerslist: action.getmergerslist };
    case GET_MERGER_MINE:
      return { ...state, getminemergerslist: action.getminemergerslist };
    case GET_MERGER_BY_ID:
      return { ...state, getmergersbyid: action.getmergersbyid };
    case GET_FILTERD_MERGER:
      return { ...state, getfilterdmergers: action.getfilterdmergers };
    case GET_MINE_MERGERS_ORDER_DETAILS:
      return { ...state, minemergersorderlist: action.minemergersorderlist };
    case GET_MERGERS_ORDER_DETAILS:
      return { ...state, mergersorderlist: action.mergersorderlist };
    default:
      return state;
  }
};
